// @ts-ignore

// Native cookie helpers (replaces js-cookie library)
const Cookies = {
  // @ts-ignore
  get: function(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for(let i = 0; i < cookies.length; i++) {
      // @ts-ignore
      let cookie = cookies[i].trim();
      if(cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }
    return undefined;
  },
  // @ts-ignore
  set: function(name, value, options) {
    let cookieStr = name + "=" + encodeURIComponent(value);
    if(options && options.expires) {
      const date = new Date();
      date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      cookieStr += "; expires=" + date.toUTCString();
    }
    cookieStr += "; path=/";
    document.cookie = cookieStr;
  }
};

const newsletterTargetNode = document.querySelector('.newsletter-popup');
if(newsletterTargetNode && newsletterTargetNode !== null) {
  const newsletterObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (newsletterTargetNode.classList.contains('active')) {
          const iframe = newsletterTargetNode.querySelector('iframe');
          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage({
              action: 'resize',
              iframe: iframe?.getAttribute('src') || iframe?.src || ''
            }, '*');
          }
        }
      }
    }
  });
  newsletterObserver.observe(newsletterTargetNode, { attributes: true });
}

// @ts-ignore
$(function () {
  // $('.newsletter-popup').addClass('active');
  var newsletter_popup_texts = general.decodeLocale(
      // @ts-ignore
      window.kef.newsletter_popup.texts,
    ),
    newsletter_popup_show_duration =
      // @ts-ignore
      window.kef.newsletter_popup.show_duration * 1000,
    // @ts-ignore
    newsletter_popup_hide_duration = window.kef.newsletter_popup.hide_duration;

  var newsletter_popup_name = "newsletter_popup",
    // @ts-ignore
    newsletter_popup_cookie = Cookies.get(newsletter_popup_name);

  var newsletter_popup_success_name = "newsletter_popup_success",
    // @ts-ignore
    newsletter_popup_success_cookie = Cookies.get(
      newsletter_popup_success_name,
    );

  if (
    window.location.href.indexOf("&form_type=customer#newsletter-popup-form") >=
    0
  ) {
    // validation error
    // @ts-ignore
    $(".newsletter-popup").addClass("active");
    // @ts-ignore
    if ($(".newsletter-popup .errors").length == 0) {
      var email_exist_el = `<div class="errors"><ul><li>${newsletter_popup_texts.error.email_exist}</li></ul></div>`;
      // @ts-ignore
      $(email_exist_el).insertAfter(
        ".newsletter-popup-homepage .newsletter-popup-box-content-text",
      );
      // @ts-ignore
      $(email_exist_el).insertAfter(
        ".newsletter-popup-page .newsletter-griditem-form",
      );
    }

    // @ts-ignore
    $("body").trigger({
      type: "newsletter_popup_show",
      datalayer_name: "view_welcome_pop_up_banner",
      datalayer_parameter: {
        page_name: "",
      },
    });
  } else if (
    window.location.href.indexOf(
      "?customer_posted=true#newsletter-popup-form",
    ) >= 0 &&
    typeof newsletter_popup_success_cookie === "undefined"
  ) {
    // success
    // @ts-ignore
    $(".newsletter-popup").addClass("active");

    // @ts-ignore
    Cookies.set(
      newsletter_popup_name,
      Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15),
      {
        expires: newsletter_popup_hide_duration,
      },
    );
    // @ts-ignore
    Cookies.set(
      newsletter_popup_success_name,
      Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15),
      {
        expires: newsletter_popup_hide_duration,
      },
    );
  } else if (typeof newsletter_popup_cookie === "undefined") {
    // hide
    setTimeout(function () {
      // @ts-ignore
      $(".newsletter-popup").addClass("active");

      // @ts-ignore
      Cookies.set(
        newsletter_popup_name,
        Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15),
        {
          expires: newsletter_popup_hide_duration,
        },
      );

      // @ts-ignore
      $("body").trigger({
        type: "newsletter_popup_show",
        datalayer_name: "view_welcome_pop_up_banner",
        datalayer_parameter: {
          page_name: "",
        },
      });
    }, newsletter_popup_show_duration);
  } else {
    // $('.newsletter-popup').remove();
  }

  // @ts-ignore
  $(".newsletter-popup-close").on("click", function () {
    // $('.newsletter-popup').remove();
    // @ts-ignore
    $(".newsletter-popup").removeClass("active");

    var click_location =
      // @ts-ignore
      $(this).get(0).nodeName == "BUTTON" ? "close icon" : "pass button";
    if (
      // @ts-ignore
      $(this).parents(".newsletter-popup").find(".newsletter-popup-after")
        .length == 0
    ) {
      // @ts-ignore
      $("body").trigger({
        type: "newsletter_popup_close",
        datalayer_name: "close_welcome_pop_up_banner",
        datalayer_parameter: {
          click_location: click_location,
          click_page: "",
        },
      });
    }
  });
  // @ts-ignore
  $("body").on("click", function (e) {
    // @ts-ignore
    var _t = $(e.target),
      popup_box = _t.parents(".newsletter-popup-box"),
      popup = _t.parents(".newsletter-popup");
    if (popup_box.length == 1) {
    } else if (popup.hasClass("active")) {
      // $('.newsletter-popup').remove();
      // @ts-ignore
      $(".newsletter-popup").removeClass("active");

      var click_location = "grey area";
      if (
        // @ts-ignore
        $(".newsletter-popup.active").find(".newsletter-popup-after").length ==
        0
      ) {
        // @ts-ignore
        $("body").trigger({
          type: "newsletter_popup_close",
          datalayer_name: "close_welcome_pop_up_banner",
          datalayer_parameter: {
            click_location: click_location,
            click_page: "",
          },
        });
      }
    }
  });
  // @ts-ignore
  $(".newsletter-popup")
    .on("click", 'a[href*="/pages/"]', function () {
      // @ts-ignore
      var href = $(this).attr("href");
      var url_obj = new URL(href, window.location.origin);
      var record_id = url_obj.pathname.split("/").slice(-1)[0];

      var click_location = "Welcome Pop-up banner";
      // if ($('.newsletter-popup.active').find('.newsletter-popup-after').length == 1) {
      //   click_location += ' - thank you page';
      // }

      // @ts-ignore
      $("body").trigger({
        type: "newsletter_popup_page_link",
        datalayer_name: "click_info_page_link",
        datalayer_parameter: {
          page_name: record_id,
          click_location: click_location,
          click_page: "",
        },
      });
    })
    .on(
      "click",
      // @ts-ignore
      `a[href*="${window.kef.sso.url}/auth/signup_with_email"], a[href*="${window.kef.sso.url_alt}/auth/signup_with_email"]`,
      // @ts-ignore
      // @ts-ignore
      function (e) {
        var click_location = "Welcome Pop-up banner";
        // if ($('.newsletter-popup.active').find('.newsletter-popup-after').length == 1) {
        //   click_location += ' - thank you page';
        // }

        // @ts-ignore
        $("body").trigger({
          type: "newsletter_popup_sso_link",
          datalayer_name: "click_sign_up_link",
          datalayer_parameter: {
            click_location: click_location,
            click_page: "",
          },
        });
      },
    )
    .on("click", 'button[type="submit"]', function () {
      var click_location = "Welcome Pop-up banner";

      // @ts-ignore
      $("body").trigger({
        type: "newsletter_popup_submit",
        datalayer_name: "click_claim_discount",
        datalayer_parameter: {
          click_location: click_location,
          click_page: "",
        },
      });
    });
});
